import { useEffect, useMemo } from "react";
import ReportUtils from "../../../../../utils/report-utils.js";

export default function ReportContent({ data, boName, tableColumns }) {
    useEffect(() => {
        ReportUtils.createExportableTable(null, null, "Ações por natureza", "nature-actions-data",);
    }, [data, tableColumns]);

    const result = data ?? [];
    const totals = useMemo(
        () =>
            result.reduce(
                (accumulator, element) => ({
                    attendanceTotal: accumulator.attendanceTotal + parseInt(element.attendance_quantity ?? 0, 10),
                    dispatchTotal: accumulator.dispatchTotal + parseInt(element.dispatch_quantity ?? 0, 10),
                    bosTotal: accumulator.bosTotal + parseInt(element.bos_quantity ?? 0, 10),
                }),

                { attendanceTotal: 0, dispatchTotal: 0, bosTotal: 0 },
            ),
        [result],
    );

    const columns = [
        { id: "nature", className: "w-[28%]", render: (item) => item.nature ?? "" },
        { id: "group", className: "w-[18%]", render: (item) => item.group_reason ?? "" },
        { id: "attendanceQuantity", className: "w-[9%]", render: (item) => item.attendance_quantity ?? 0, footer: () => totals.attendanceTotal },
        { id: "attendancePercent", className: "w-[9%]", render: (item) => item.attendance_percent ?? "0%", footer: () => (totals.attendanceTotal === 0 ? "0%" : "100%") },
        { id: "dispatchQuantity", className: "w-[9%]", render: (item) => item.dispatch_quantity ?? 0, footer: () => totals.dispatchTotal },
        { id: "dispatchPercent", className: "w-[9%]", render: (item) => item.dispatch_percent ?? "0%", footer: () => (totals.dispatchTotal === 0 ? "0%" : "100%") },
        { id: "boQuantity", className: "w-[9%] cursor-pointer", title: `Apenas ${boName} aprovados`, render: (item) => item.bos_quantity ?? 0, footer: () => totals.bosTotal },
        { id: "boPercent", className: "w-[9%] cursor-pointer", title: `Apenas ${boName} aprovados`, render: (item) => item.bos_percent ?? "0%", footer: () => (totals.bosTotal === 0 ? "0%" : "100%") },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    return (
        <>
            {visibleColumns.length ? (
                <table id="nature-actions-data" className="table report-table" sheet-name="Ações por natureza">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column) => (
                                <th key={column.id} className={column.className} title={column.title}>
                                    {tableColumns[column.id].label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {result.map((item, index) => (
                            <tr key={index}>
                                {visibleColumns.map((column) => (
                                    <td key={column.id} className={column.className} title={column.title}>
                                        {column.render(item)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column, index) => (
                                <th key={column.id} className={column.className} title={column.title}>
                                    {index === 0 ? "TOTAL" : (column.footer?.() ?? "")}
                                </th>
                            ))}
                        </tr>
                    </tfoot>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <span className="obs-warn mt-4"><p>* O total de {boName} pode apresentar divergência devido aos cadastros com múltiplas naturezas</p></span>

            <div id="chart-tables"/>
        </>
    );
}